import type { ApplicationContext } from './shared-types'

import reconciledStatusService from '@app/application/solid/services/reconciled-status-service'

// Instantiated at bundle evaluation — before the Solid SPA's module script
// can emit — so an emit that beats a Stimulus controller's connect is
// buffered instead of lost.
//
// A Turbolinks visit (e.g. the reconciliation navigation carousel) tears the
// page singleton down without re-evaluating the bundle, so re-arm it on
// turbolinks:load: the new body is in place by then — the old page's emits
// can no longer be recorded — while the new page's SPA module script is
// still being fetched.
export default (appContext: ApplicationContext): ApplicationContext => {
  reconciledStatusService()

  appContext.onDomLoad(reconciledStatusService)

  return appContext
}
